import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72b97451"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "px-2",
  style: {"max-height":"calc(100vh - 3rem)","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_2 = {
  key: 0,
  class: "text-muted fs-7 p-3"
}
const _hoisted_3 = { class: "qd-sticky-top pb-3 border-bottom border-gray-200" }
const _hoisted_4 = { class: "d-flex align-items-start justify-content-between" }
const _hoisted_5 = { class: "pe-3" }
const _hoisted_6 = { class: "fs-4 fw-bold text-gray-900" }
const _hoisted_7 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_8 = { class: "fw-semibold text-gray-700" }
const _hoisted_9 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_10 = { class: "d-flex flex-wrap gap-2 mt-2" }
const _hoisted_11 = {
  key: 1,
  class: "badge badge-light-warning"
}
const _hoisted_12 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4 mt-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary mb-3" }, "Thông tin ứng viên", -1))
const _hoisted_14 = { class: "row g-3" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Điện thoại", -1))
const _hoisted_17 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "CMND/CCCD", -1))
const _hoisted_20 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Trường L12", -1))
const _hoisted_23 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tỉnh/TP L12", -1))
const _hoisted_26 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_27 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded p-4 mb-4"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary mb-3" }, "Hồ sơ xét tuyển", -1))
const _hoisted_29 = { class: "row g-3 mb-1" }
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Mã hồ sơ", -1))
const _hoisted_32 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Hình thức xét", -1))
const _hoisted_35 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8 mb-1" }, "Ngành đăng ký", -1))
const _hoisted_37 = { class: "badge badge-light fs-9" }
const _hoisted_38 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_39 = {
  key: 0,
  class: "badge badge-light-success fs-9"
}
const _hoisted_40 = {
  key: 1,
  class: "badge badge-light-danger fs-9"
}
const _hoisted_41 = { class: "border border-primary border-dashed rounded p-4 mb-4 umt-form bg-light-primary" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary mb-3" }, "Học bổng đăng ký", -1))
const _hoisted_43 = {
  key: 0,
  class: "row g-3"
}
const _hoisted_44 = { class: "col-12" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-gray-600 mb-1 required" }, "Đăng ký xét học bổng", -1))
const _hoisted_46 = { class: "col-12" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-gray-600 mb-1 required" }, "Ngành (kèm mã hồ sơ)", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 fst-italic mt-1" }, "Chọn ngành sẽ tự gắn mã hồ sơ (MHS) chứa ngành đó.", -1))
const _hoisted_49 = {
  key: 1,
  class: "row g-3"
}
const _hoisted_50 = { class: "col-12" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Học bổng đăng ký", -1))
const _hoisted_52 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_53 = { class: "col-6" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngành", -1))
const _hoisted_55 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_56 = { class: "col-6" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Mã hồ sơ", -1))
const _hoisted_58 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_59 = { class: "col-6" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày tạo", -1))
const _hoisted_61 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_62 = { class: "col-6" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Cập nhật", -1))
const _hoisted_64 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_65 = {
  key: 1,
  class: "border border-success border-dashed rounded p-4 mb-4 umt-form bg-light-success"
}
const _hoisted_66 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-success" }, "Học bổng đã cấp", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-7" }, null, -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { class: "row g-3" }
const _hoisted_71 = { class: "col-12" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Học bổng", -1))
const _hoisted_73 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_74 = { class: "col-4" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-gray-600 mb-1 required" }, "Số thông báo", -1))
const _hoisted_76 = { class: "col-4" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-gray-600 mb-1 required" }, "Ngày thông báo", -1))
const _hoisted_78 = { class: "col-4" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-gray-600 mb-1 required" }, "Đợt xét", -1))
const _hoisted_80 = { class: "col-12 d-flex justify-content-end gap-2" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_83 = { class: "col-4" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Số thông báo", -1))
const _hoisted_85 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_86 = { class: "col-4" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày thông báo", -1))
const _hoisted_88 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_89 = { class: "col-4" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Đợt xét", -1))
const _hoisted_91 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_92 = { class: "col-4" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Người duyệt", -1))
const _hoisted_94 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_95 = { class: "col-4" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày duyệt", -1))
const _hoisted_97 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_99 = { class: "col-4" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Người sửa cuối", -1))
const _hoisted_101 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_102 = { class: "col-4" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Sửa lần cuối", -1))
const _hoisted_104 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_106 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded p-4 mb-4"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-danger mb-3" }, "Từ chối cấp học bổng", -1))
const _hoisted_108 = { class: "row g-3" }
const _hoisted_109 = { class: "col-12" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Lý do từ chối", -1))
const _hoisted_111 = { class: "col-6" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Người từ chối", -1))
const _hoisted_113 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_114 = { class: "col-6" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày từ chối", -1))
const _hoisted_116 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_117 = { class: "qd-sticky-bottom d-flex justify-content-end py-3 border-top border-gray-200" }
const _hoisted_118 = ["disabled"]
const _hoisted_119 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil me-1 fs-8" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.visible) = $event)),
    direction: "rtl",
    size: "500px",
    "with-header": false,
    "append-to-body": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Đang tải…"))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.d.studentName || _ctx.d.Student?.fullName || 'Ứng viên'), 1),
                    (_ctx.d.Student?.idCard)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createTextVNode("CCCD: "),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.d.Student.idCard), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", {
                    class: "btn btn-sm btn-icon btn-active-light-primary flex-shrink-0",
                    title: "Đóng",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = false))
                  }, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.d.status)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(`badge badge-light-${_ctx.badgeStatus[_ctx.d.status]?.badge || 'info'}`)
                      }, _toDisplayString(_ctx.badgeStatus[_ctx.d.status]?.label || _ctx.d.status), 3))
                    : _createCommentVNode("", true),
                  (_ctx.isEditing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Đang chỉnh sửa"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.d.Student?.phone || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.d.Student?.idCard || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.d.Student?.class12School?.name || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.d.Student?.class12Province?.name || '—'), 1)
                  ])
                ])
              ]),
              (_ctx.adRegInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.adRegInfo.profileCode || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.adRegInfo.method || '—'), 1)
                      ])
                    ]),
                    _hoisted_36,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adRegInfo.majors, (m, mi) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: mi,
                        class: _normalizeClass(["d-flex align-items-center flex-wrap gap-2 py-1", { 'border-top border-gray-200 border-dashed': mi > 0 }])
                      }, [
                        _createElementVNode("span", _hoisted_37, "NV" + _toDisplayString(m.priority || mi + 1), 1),
                        _createElementVNode("span", _hoisted_38, _toDisplayString(m.name), 1),
                        (m.adForm)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(m.adForm), 1))
                          : _createCommentVNode("", true),
                        (m.averageScore)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(m.averageScore), 1))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                (_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          filterable: "",
                          modelValue: _ctx.editForm.regScholarshipId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editForm.regScholarshipId) = $event)),
                          placeholder: "Loại học bổng"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scholarshipOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: `${item.name} (${item.code})`,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          filterable: "",
                          modelValue: _ctx.editForm.majorId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editForm.majorId) = $event)),
                          placeholder: "Ngành"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.majorOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id + '-' + item.admissionRegisterId,
                                label: `${item.name} — ${item.profileCode}`,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _hoisted_48
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.d.regScholarshipName ? `${_ctx.d.regScholarshipName}${_ctx.d.regScholarshipCode ? ` (${_ctx.d.regScholarshipCode})` : ''}` : '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.d.majorName || _ctx.grant.majorName || _ctx.grant.majorCode || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.d.admissionRegisterCode || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.fmtDate(_ctx.d.createdAt)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _hoisted_63,
                        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.fmtDate(_ctx.d.updatedAt)), 1)
                      ])
                    ]))
              ]),
              (_ctx.d.status == 'approved')
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      (!_ctx.editingIssued)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "btn btn-sm btn-icon btn-light btn-active-light-primary",
                            title: "Sửa thông tin quyết định (Số/Ngày thông báo, Đợt xét)",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startEditIssued && _ctx.startEditIssued(...args)))
                          }, _hoisted_69))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.d.issuedScholarshipName ? `${_ctx.d.issuedScholarshipName}${(_ctx.d.issuedScholarshipCode || _ctx.grant.scholarshipCode) ? ` (${_ctx.d.issuedScholarshipCode || _ctx.grant.scholarshipCode})` : ''}` : (_ctx.grant.description || _ctx.grant.scholarshipType || _ctx.grant.scholarshipCode || '—')), 1)
                      ]),
                      (_ctx.editingIssued)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.issuedForm.issuedNo,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.issuedForm.issuedNo) = $event)),
                                placeholder: "Số thông báo"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              _hoisted_77,
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.issuedForm.issuedDate,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.issuedForm.issuedDate) = $event)),
                                type: "date",
                                placeholder: "Ngày/tháng/năm",
                                format: "DD/MM/YYYY"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _hoisted_79,
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.issuedForm.issuedPhase,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.issuedForm.issuedPhase) = $event)),
                                placeholder: "Đợt"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("span", {
                                class: "btn btn-sm btn-light umt-btn-32",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editingIssued = false))
                              }, "Hủy"),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-primary umt-btn-32",
                                disabled: _ctx.savingIssued || !_ctx.issuedForm.issuedNo || !_ctx.issuedForm.issuedDate || !_ctx.issuedForm.issuedPhase,
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveIssued && _ctx.saveIssued(...args)))
                              }, [
                                (_ctx.savingIssued)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_82))
                                  : _createCommentVNode("", true),
                                _createTextVNode("Lưu ")
                              ], 8, _hoisted_81)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_83, [
                              _hoisted_84,
                              _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.d.issuedNo || _ctx.grant.issuedNo || '—'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_86, [
                              _hoisted_87,
                              _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.fmtDate(_ctx.d.issuedDate || _ctx.grant.issuedDate)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_89, [
                              _hoisted_90,
                              _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.d.issuedPhase || _ctx.grant.issuedPhase || '—'), 1)
                            ])
                          ], 64)),
                      _createElementVNode("div", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.approverName || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _hoisted_96,
                        _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.fmtDateTime(_ctx.d.approvedAt || _ctx.d.updatedAt)), 1)
                      ]),
                      _hoisted_98,
                      (_ctx.editedAfterApprove)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("div", _hoisted_99, [
                              _hoisted_100,
                              _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.actorName || '—'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_102, [
                              _hoisted_103,
                              _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.fmtDateTime(_ctx.d.updatedAt)), 1)
                            ]),
                            _hoisted_105
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.d.status == 'rejected')
                ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                    _hoisted_107,
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("div", _hoisted_109, [
                        _hoisted_110,
                        _createElementVNode("div", {
                          class: _normalizeClass(["fs-7", _ctx.rejectReason ? 'text-gray-900 fw-semibold' : 'text-muted fst-italic'])
                        }, _toDisplayString(_ctx.rejectReason || '(không ghi lý do)'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_111, [
                        _hoisted_112,
                        _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.actorName || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_114, [
                        _hoisted_115,
                        _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.fmtDateTime(_ctx.d.updatedAt)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_117, [
                (_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", {
                        class: "btn btn-white btn-active-light-primary me-2 umt-btn-32",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                      }, "Hủy"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary umt-btn-32",
                        disabled: _ctx.saving || !_ctx.editForm.regScholarshipId || !_ctx.editForm.majorId,
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                      }, [
                        (_ctx.saving)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_119))
                          : _createCommentVNode("", true),
                        _createTextVNode("Lưu ")
                      ], 8, _hoisted_118)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("span", {
                        class: "btn btn-white btn-active-light-primary me-2 umt-btn-32",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.visible = false))
                      }, "Đóng"),
                      (_ctx.canEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-primary umt-btn-32",
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.startEdit && _ctx.startEdit(...args)))
                          }, [
                            _hoisted_120,
                            _createTextVNode("Chỉnh sửa ")
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
              ])
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}